export default __webpack_public_path__ + "5d5c8a91fbbe7d06e758ef0e624f3d91.png";